import React from 'react';

import { FilePondErrorDescription, FilePondFile } from 'filepond';
import { FilePond, registerPlugin } from 'react-filepond';

import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
// Import FilePond styles
import { TOAST_TYPES, useNotificationsContext } from '@evolve/common-ui';
import 'filepond/dist/filepond.min.css';
import '../../../styles/filepond-styles.css';

registerPlugin(FilePondPluginFileValidateType);
registerPlugin(FilePondPluginFileValidateSize);

const MAX_FILE_SIZE = '5MB';
const MAX_FILES = 5;

export type DocumentInputProps = {
  allowMultiple?: boolean;
  acceptedFileTypes?: string[];
  labelIdle?: string;
  maxFileSize?: string;
  maxFiles?: number;
  onwarning?: (error: FilePondErrorDescription) => void;
  checkValidity?: boolean;
  dropOnPage?: boolean;
  labelFileTypeNotAllowed?: string;
  fileValidateTypeLabelExpectedTypes?: string;
  labelMaxFileSizeExceeded?: string;
  labelMaxFileSize?: string;
  onupdatefiles?: (files: FilePondFile[]) => void;
};

export function DocumentInput(props: DocumentInputProps) {
  const { addNotification } = useNotificationsContext();

  const warningMessagesPond = (error: number) => {
    switch (error) {
      case 0:
        return `No máximo pode fazer upload de ${props.maxFiles ?? MAX_FILES} ficheiros.`;
      default:
        return 'Erro desconhecido ao faze o upload dos ficheiros.';
    }
  };

  const onFail = (error: FilePondErrorDescription) => {
    addNotification({
      id: Date.now(),
      title: 'Erro!',
      message: warningMessagesPond(error.code),
      timeout: 5000,
      type: TOAST_TYPES.ERROR,
    });
  };

  const {
    acceptedFileTypes = ['application/pdf'],
    labelIdle = "Arraste & Solte os documentos ou <span class='font-semibold text-evolve-primary hover:cursor-pointer'> Procurar... </span>",
    maxFileSize = MAX_FILE_SIZE,
    allowMultiple = true,
    maxFiles = MAX_FILES,
    onwarning = onFail,
    checkValidity = true,
    dropOnPage = true,
    labelFileTypeNotAllowed = 'Tipo de ficheiro inválido',
    fileValidateTypeLabelExpectedTypes = 'Apenas são permitidos ficheiros PDF',
    labelMaxFileSizeExceeded = 'Ficheiro demasiado grande',
    labelMaxFileSize = 'O tamanho do ficheiro não deve exceder {filesize}',
    ...restProps
  } = props;

  return (
    <div className={'mt-2'}>
      <FilePond
        acceptedFileTypes={acceptedFileTypes}
        labelIdle={labelIdle}
        maxFileSize={maxFileSize}
        allowMultiple={allowMultiple}
        maxFiles={maxFiles}
        onwarning={onwarning}
        credits={false}
        checkValidity={checkValidity}
        dropOnPage={dropOnPage}
        labelFileTypeNotAllowed={labelFileTypeNotAllowed}
        fileValidateTypeLabelExpectedTypes={fileValidateTypeLabelExpectedTypes}
        labelMaxFileSizeExceeded={labelMaxFileSizeExceeded}
        labelMaxFileSize={labelMaxFileSize}
        {...restProps}
      />
    </div>
  );
}
